<template>
    <div
        class="action-dropdown-option"
        :class="{ disabled, selected }"
        @click="$emit('pressed')"
    >
        {{ text }}
    </div>
</template>
<script setup lang="ts">
import { defineEmits, defineProps } from 'vue';

interface Props {
    text: string;
    disabled?: boolean;
    selected?: boolean;
}

const $emit = defineEmits(['pressed']);
defineProps<Props>();

</script>
<style lang="scss">
@import './style.scss';
</style>